function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext } from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import classNamesMaker from "classnames";
import { Button, BUTTON_TYPES, BUTTON_VARIANT } from "#library/components/Button";
import IconArrowRight from "#library/assets/icons/jds_arrowRight.svg";
import styles from "./arrow.module.css";
export var RightArrow = function RightArrow() {
  var _useContext = useContext(VisibilityContext),
    initComplete = _useContext.initComplete,
    isLastItemVisible = _useContext.isLastItemVisible,
    scrollNext = _useContext.scrollNext;
  var classNames = classNamesMaker(styles["jds-arrow"], _defineProperty({}, styles["jds-arrow--hidden"], !initComplete || initComplete && isLastItemVisible));
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames,
    type: BUTTON_TYPES.BUTTON,
    icon: IconArrowRight,
    variant: BUTTON_VARIANT.GHOST_INVERTED,
    onClick: function onClick() {
      return scrollNext();
    },
    minor: true,
    "aria-label": "right arrow"
  });
};